import { unsplash, unsplashSet } from "@/lib/img";

const ITEMS = [
  {
    title: "Staubsauger",
    image:
      "https://images.unsplash.com/photo-1569698134101-f15cde5cd66c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjB2YWN1dW0lMjBjbGVhbmVyJTIwbWFjaGluZXxlbnwwfHx8fDE3ODM5NjMwMTh8MA&ixlib=rb-4.1.0&q=85",
    alt: "Professioneller Staubsauger",
  },
  {
    title: "Mikrofasertücher",
    image:
      "https://images.unsplash.com/photo-1612800317101-ed7de737b36f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzdGFjayUyMG1pY3JvZmliZXIlMjBjbGVhbmluZyUyMGNsb3Roc3xlbnwwfHx8fDE3ODM5NjMwMTh8MA&ixlib=rb-4.1.0&q=85",
    alt: "Mikrofasertücher für die Reinigung",
  },
  {
    title: "Mopp & Eimer",
    image:
      "https://images.unsplash.com/photo-1749214317455-efbdd57df844?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxtb3AlMjBhbmQlMjBidWNrZXQlMjBmbG9vciUyMGNsZWFuaW5nfGVufDB8fHx8MTc4Mzk2MzAxOHww&ixlib=rb-4.1.0&q=85",
    alt: "Mopp und Eimer für die Bodenreinigung",
  },
  {
    title: "Reinigungswagen",
    image:
      "https://images.unsplash.com/photo-1611416553159-262dd1e1c5c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxqYW5pdG9yJTIwY2xlYW5pbmclMjBjYXJ0JTIwdHJvbGxleSUyMHN1cHBsaWVzfGVufDB8fHx8MTc4Mzk2MzAxOHww&ixlib=rb-4.1.0&q=85",
    alt: "Reinigungswagen mit Ausrüstung",
  },
  {
    title: "Reinigungsmittel",
    image:
      "https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjbGVhbmluZyUyMHByb2R1Y3RzJTIwc3ByYXklMjBib3R0bGVzJTIwdG9vbHN8ZW58MHx8fHwxNzgzOTYzMDE4fDA&ixlib=rb-4.1.0&q=85",
    alt: "Reinigungsmittel und Sprühflasche",
  },
];

export const Equipment = () => {
  return (
    <section data-testid="equipment-section" className="py-24 md:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#0077E6] mb-4">
            Ausstattung
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A192F]">
            Professionelle Ausstattung
          </h2>
          <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed">
            Für gründliche und zuverlässige Ergebnisse arbeiten wir mit
            professioneller Reinigungsausrüstung und geeigneten Reinigungsmitteln.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6">
          {ITEMS.map((item, i) => (
            <div
              key={item.title}
              data-testid={`equipment-${i}`}
              className="group overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-[0_8px_30px_rgb(10,25,47,0.04)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(10,25,47,0.09)] transition-all duration-300"
            >
              <div className="h-36 overflow-hidden">
                <img
                  src={unsplash(item.image, 400)}
                  srcSet={unsplashSet(item.image, [200, 300, 400])}
                  sizes="(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 20vw"
                  alt={item.alt}
                  width="400"
                  height="288"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <p className="px-4 py-4 text-center text-sm font-semibold text-[#0A192F]">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
